/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import contact from '../../images/Contact/contact.png';
import arrow from '../../images/TopBanner/right-arrow.png';
import './Contact.scss';

const Contact = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = (data) => console.log(data);

    return (
        <section className="mt-5 mb-5">
            <Container>
                <Row className="d-flex align-items-center">
                    <Col md={6} data-aos="fade-right" data-aos-duration="1500">
                        <img src={contact} className="img-fluid" alt="" />
                    </Col>
                    <Col md={6}>
                        <h3
                            className="mb-5 contact-heading"
                            data-aos="zoom-out-right"
                            data-aos-duration="2000"
                        >
                            Say hello!
                        </h3>
                        <Form
                            onSubmit={handleSubmit(onSubmit)}
                            className="contact-form"
                            data-aos="fade-up"
                            data-aos-duration="1500"
                        >
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="formBasicText">
                                        <Form.Label>NAME</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Your name"
                                            {...register('name', { required: true })}
                                        />
                                        {errors.name && <span>This field is required</span>}
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicText1">
                                        <Form.Label>SUBJECT</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Choose a subject"
                                            {...register('subject', { required: true })}
                                        />
                                        {errors.subject && <span>This field is required</span>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="formBasicText2">
                                        <Form.Label>COMPANY</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Text here"
                                            {...register('company', { required: true })}
                                        />
                                        {errors.company && <span>This field is required</span>}
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>EMAIL</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="You email address"
                                            {...register('email', { required: true })}
                                        />
                                        {errors.email && <span>This field is required</span>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3" controlId="formBasicText3">
                                <Form.Label>MESSAGE</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Start typing here"
                                    rows={4}
                                    {...register('message', { required: true })}
                                />
                                {errors.message && <span>This field is required</span>}
                            </Form.Group>
                            <div className="text-center mt-5">
                                <Button className="px-5 py-2" variant="primary" type="submit">
                                    Submit here <img src={arrow} alt="" />
                                </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
export default Contact;
